<template lang="pug">
  v-data-table(
    :items="items"
    :headers="headers"
    hide-default-footer
    disable-pagination
  )
    template(v-slot:item.journal_task_status="{ item }")
      span {{ TASK_STATUS_NAMES[item.journal_task_status] }}
    template(v-slot:item.status="{ item }")
      v-btn(
        v-if="isPassButtonVisible(item.journal_task_status)"
        :to=`{
          name: 'TaskPass',
          params: { id: item.task_id },
          query: { groupId: $route.params.groupId },
        }`
        color="success"
        rounded
      ) Пройти
    template(v-slot:item.comment="{ item }")
      sdo-dialog(:button-options="{ label: 'Показать', color: 'success', text: 'text' }")
        template(v-slot:header) Комментарий к заданию
        template(v-slot:body) {{ item.comment }}

</template>

<script>
import { TASK_STATUS_NAMES, TASK_STATUSES } from '@/utils/constants';
import SdoDialog from '@/components/Global/SdoDialog.vue';

export default {
  name: 'TaskTable',
  components: { SdoDialog },
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    headers: [
      { text: 'Задание', value: 'task_name' },
      { text: 'Статус', value: 'journal_task_status' },
      { text: 'Ссылка на задание', value: 'status' },
      { text: 'Отметка', value: 'mark' },
      { text: 'Комментарий', value: 'comment' },
    ],
    TASK_STATUSES,
    TASK_STATUS_NAMES,
  }),
  methods: {
    isPassButtonVisible(taskStatus) {
      return taskStatus === TASK_STATUSES.retake || taskStatus === TASK_STATUSES.notPassed;
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-data-table {
    box-shadow: 0 2px 8px -7px rgba(0, 0, 0, 0.8)
  }
</style>
